module.exports = __webpack_public_path__ + "static/media/title-en.d47266eb.png";